/** @file viewportBindingLabels: human labels of the viewport bindings T-315 added (camera presets). */

/** Binding id to label, merged into the shell's `bindingLabels` (the Shortcuts dialog, Settings, menus). */
export const viewportBindingLabels: Readonly<Record<string, string>> = {
  'viewport.view.front': 'Front view (yaw 0)', 'viewport.view.right': 'Right side view (yaw 90)',
  'viewport.view.top': 'Top view (steepest pitch)', 'viewport.view.profilePitch': 'Toggle the profile pitch',
};
